import { render, staticRenderFns } from "./index.vue?vue&type=template&id=80990e76&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80990e76')) {
      api.createRecord('80990e76', component.options)
    } else {
      api.reload('80990e76', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=80990e76&", function () {
      api.rerender('80990e76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/invoice/index.vue"
export default component.exports